import DoughnutChart from '../charts/DoughnutChart.js';
import moment from "moment";
import Paginate from 'vuejs-paginate';

if ($('#admin-doughnut-chart').length) {
    var app = new Vue({
        el: '#admin-doughnut-chart',
        data: {
            applicationResponse: {},
            doughnutOptions: {
                responsive: true,
                maintainAspectRatio: false,
                cutoutPercentage: 85,
                legend: {
                    display: false
                },
            },
            myStyles: {
                height: '150px',
                width: '100%',
                marginTop: '10px'
            },
            data: {},
            pagination: [],
            responses: {
                labels: [
                    'Pending',
                    'Not Interested',
                    'Unsure',
                    'Interested'
                ],
                colors: [
                    '#ccc',
                    '#e20d0d',
                    '#f8a01c',
                    '#2dcc70'
                ]
            },
            networkStatus: networkStatus,
            type: type,
            networkFilter: networkFilter,
            loading: true,
            now: moment().format(),
            myPlugins: {
                afterDatasetDraw: function (chart) {
                    if (chart.config.data.image) {
                        let ctx = chart.chart.ctx, image = new Image(), imageSize = 85;
                        ctx.save();
                        image.src = chart.config.data.image;
                        ctx.drawImage(image, chart.chart.width / 2 - imageSize / 2, chart.chart.height / 2 - imageSize / 2, imageSize, imageSize);
                        ctx.restore();
                    }
                }
            }
        },
        methods: {
            get: function (page = 1) {
                this.loading = true
                this.data = {}
                let params = '?page=' + page;
                if (this.networkStatus) {
                    params += '&network_status=' + this.networkStatus;
                }
                if (this.type) {
                    params += '&type=' + this.type;
                }
                if (this.networkFilter) {
                    params += '&network_filter=' + this.networkFilter;
                }
                axios.get('/api/v1/challenges/summary' + params).then((response) => {
                    if (response.data) {
                        let scrollPosition = null;
                        if (sessionStorage.scrollPos && sessionStorage.scrollPos != 0) {
                            scrollPosition = sessionStorage.scrollPos;
                        }
                        this.$nextTick(() => {
                            $(window).scrollTop(scrollPosition)
                        });
                        this.data = response.data.data;
                        this.pagination = response.data;
                        this.data.forEach((value, index) => {
                            if (value.applicationResponses.length) {
                                this.data[index].applicationResponse = this.generateResponseChartData(value.applicationResponses, value.image_location);
                            }
                        });
                        this.loading = false
                    }
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            getResponseTotal(id, data) {
                if (data) {
                    let response = data.filter(obj => {
                        return obj.application_response_id === id
                    });
                    if (response[0]) {
                        return response[0].total;
                    } else {
                        return 0;
                    }
                }
            },
            generateResponseChartData(object, image) {
                var data = [];
                var colors = [];
                var labels = [];
                var responses = this.responses;

                object.forEach(function (response) {
                    if (response.application_response_id != null) {
                        labels.push(responses.labels[response.application_response_id]);
                        colors.push(responses.colors[response.application_response_id]);
                    } else {
                        labels.push('Pending');
                        colors.push('#999');
                    }
                    data.push(response.total);
                });

                return {
                    labels: labels,
                    datasets: [
                        {
                            backgroundColor: colors,
                            data: data
                        }
                    ],
                    image: image
                }
            },
            expiryDate(expiry_date) {
                if (expiry_date) {
                    moment.locale('en-gb');
                    return moment(expiry_date).format("L");
                } else {
                    return 'N/A';
                }
            },
            getExpiry(expiry_date) {
                if (expiry_date) {
                    return moment(expiry_date).format();
                } else {
                    return moment().format();
                }
            },
            paginate(page) {
                this.get(page);
            },
            errorHandler(error) {
                if (error.response && typeof error.response.data === 'string') {
                    this.$toasted.error(error.response.data);
                } else if (error.response) {
                    this.$toasted.error(error.response.data.message);
                } else {
                    console.log(error);
                }
            },
            adminCount(users) {
                if (users) {
                    return users.length;
                } else {
                    return 0;
                }
            },
            daysRemaining(date) {
                if (date) {
                    let a = moment(date).startOf('day')
                    let b = moment().startOf('day')
                    if (a >= b) {
                        return a.diff(b, 'days')
                    } else {
                        return 0
                    }
                } else {
                    return ''
                }
            },
            getUsers(users) {
                if (users && users.length > 0) {
                    let data = '';
                    users.map(function (value) {
                        data += value.full_name + '\n'
                    });
                    return data
                } else {
                    return 'No Users'
                }
            }
        },
        components: {
            'doughnut-chart': DoughnutChart,
            'paginate': Paginate
        },
        mounted() {
            this.get();
        }
    });
}